export default __webpack_public_path__ + "static/media/donut.7d044d6b.obj";